var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 160,
    viewBox: "0 0 189 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3515 71.4638C18.9482 69.0605 18.9482 65.1641 21.3515 62.7608C23.7548 60.3575 27.6513 60.3575 30.0545 62.7608L72.1181 104.824L67.8558 109.087C65.4033 111.539 61.4269 111.539 58.9744 109.087L21.3515 71.4638Z",
    fill: "#0033A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.188 16.352C145.591 13.9487 149.487 13.9487 151.891 16.352C154.294 18.7553 154.294 22.6518 151.891 25.055L72.1172 104.828L63.4142 96.1254L143.188 16.352Z",
    fill: "#0033A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6475 101.451L92.3505 92.7481L104.638 105.035L100.376 109.298C97.923 111.75 93.9466 111.75 91.4941 109.298L83.6475 101.451Z",
    fill: "#0033A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8632 71.6669C51.46 69.2637 51.46 65.3672 53.8632 62.9639C56.2665 60.5606 60.163 60.5606 62.5663 62.9639L79.5762 79.9739L70.8732 88.6769L53.8632 71.6669Z",
    fill: "#0033A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.713 16.5571C178.116 14.1538 182.013 14.1538 184.416 16.5571C186.819 18.9604 186.819 22.8568 184.416 25.2601L104.637 105.039L95.9339 96.3361L175.713 16.5571Z",
    fill: "#0033A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2897,
    cy: 80.0021,
    r: 74.0014,
    stroke: "#0033A0",
    strokeWidth: 12.0002
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logoSymbol.c5cf1a79bc5b30b33fdf3267ef570d09.svg";
export { ForwardRef as ReactComponent };